import './global.js'
import Parse from 'parse';
import React from 'react';
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";
import $ from "jquery";
import CommonPopup from './CommonPopup.jsx';
import SaveNotification from "./saveNotification.jsx";
class ChallengeDetail extends React.Component {

    constructor(props) {
        super(props);
        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); 
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";
        let currentUser = Parse.User.current();          
        /*if(!currentUser)
        {
            window.location.href = "/";
        }*/
        this.state = {
            challenge_image:null,    
            challengeTitle:null, 
            caption:null,
            challengeHashtag:null,
            prize:null,
            sponsor:null,
            entries: {},
            create_message:null,
            create_message_show:false,
            challenge_image_msg_size:false,
            challenge: {},
            isPopupOpen: false,
            post_common_id:'',
            challengeStatus:null,
            isNotificationOpen:false,
            post_Notification_Id:'',
            post_Notification_Msg:'',
            post_Notification_Comment:''
        };         
         const queryString = window.location.href;
         var challenge_id = queryString.split("/")[4]; 
         this.checkChallengeIsAvailable(challenge_id);
         this.challenge_id=challenge_id;
         this.checkChallengeEntries(challenge_id);
         this.handleChallengeSubmit = this.handleChallengeSubmit.bind(this);
         this.checkChallengeModal = this.checkChallengeModal.bind(this);
         this.checkChallengePostModal = this.checkChallengePostModal.bind(this);
         this.handleChallengeFileChange = this.handleChallengeFileChange.bind(this);
         this.checkChallengeDiscard = this.checkChallengeDiscard.bind(this);
         this.changeChallengeCaption = this.changeChallengeCaption.bind(this);
         localStorage.setItem('storestreamtabValue', this.challenge_id);
         localStorage.setItem('storestreampagepath', 'challengedetail');
    }

  changeChallengeCaption = function(e){
    var forms = document.forms.new_challenge_form;
    var caption=forms.caption1.value;
    var dataurl_210=forms.dataurl_2101.value;
    if(caption!=='' || dataurl_210!=='') {
      $('#close_Postmodalwithdiscard1').attr("style", "display: block");
      $('#close_Postmodal1').attr("style", "display: none");
    } else {
      $('#close_Postmodalwithdiscard1').attr("style", "display: none");
      $('#close_Postmodal1').attr("style", "display: block");
    }
  }

   toggleNotification = (postid,msg,comment) => {  
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen: !prevState.isNotificationOpen,
          post_Notification_Id: postid,
          post_Notification_Msg: msg,
          post_Notification_Comment:comment 
        }));
        //self.setState({ post_Notification_Id: postid });        
      };
 checkChallengePostModal = function(e){
    var forms = document.forms.new_challenge_form;
    var caption=forms.caption1.value;
    var dataurl_210=forms.dataurl_210.value;
    if(caption!=='' || dataurl_210!=='') {
      $('#close_Postmodalwithdiscard1').attr("style", "display: block");
      $('#close_Postmodal1').attr("style", "display: none");

      if ($("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }else {
      $('#close_Postmodalwithdiscard1').attr("style", "display: none");
      $('#close_Postmodal1').attr("style", "display: block");
      if (!$("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }
  }
    
    checkChallengeModal = function(e){
    var forms = document.forms.new_challenge_form;
    var caption=forms.caption1.value;
    var dataurl_210=forms.dataurl_2101.value;
    if(caption!=='' || dataurl_210!=='') {
      $('#addChallengeModal #close_Postmodalwithdiscard1').attr("style", "display: block");
      $('#addChallengeModal #close_Postmodal1').attr("style", "display: none");

      if ($("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }else {
      $('#addChallengeModal #close_Postmodalwithdiscard1').attr("style", "display: none");
      $('#addChallengeModal #close_Postmodal1').attr("style", "display: block");
      if (!$("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $("#addChallengeModal.modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
      }
    }
  }


handleChallengeFileChange = (event) => {
    const file = event.target.files[0];   
    var self = this;  
    if(file)
    {

    const fileSizeInBytes = file.size; 
    const fileSizeInKB = fileSizeInBytes / 1024; 
    const maxSizeInKB = 20480; // 20MB

    if (fileSizeInKB > maxSizeInKB) {
       self.setState({create_message_show:true}); 
       self.setState({create_message:"File size exceeds the limit."});        
    } else {
     const fileType = file.type;    

    if (fileType === 'image/jpeg' || fileType === 'image/png') {
                let imageFile = event.target.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                var img = document.createElement("img");
                img.onload = function (event) {
                var custom_width_640=640;
                var custom_width_210=210;
                if(custom_width_640)
                {
                    var canvas = document.createElement("canvas");
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');                    
                    const maxWidth = 1000; 
                    const maxHeight = 1000; 
                    const aspectRatio = img.width / img.height;
                     let newHeightCheck=0;
                    let newWidthCheck=0;
                    let newMessageCheck='';

                    let newWidth = img.width;
                    let newHeight = img.height;
                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }
                    if(custom_width_640>newHeight || custom_width_640>newWidth )
                    {
                         //console.log('less');
                        if(custom_width_640>newHeight)
                        {
                            newHeightCheck=newHeight;
                            newMessageCheck= "Please upload a larger size image. The height proportionally is "+parseInt(newHeight)+"px, it must be at least 640px";
                        }
                        if(custom_width_640>newWidth)
                        {
                            newWidthCheck=newWidth;
                             newMessageCheck= "Please upload a larger size image. The  width proportionally is "+parseInt(newWidth)+"px, it must be at least 640px";
                        }
                        if(custom_width_640>newHeight && custom_width_640>newWidth)
                        {
                            newMessageCheck= "Please upload a larger size image. The  width/height proportionally is "+parseInt(newWidth)+"px & "+parseInt(newHeight)+"px, it must be at least 640px";
                        }
                          self.setState({challenge_image_msg_size:newMessageCheck}); 
                         //self.setState({photo_image_message:"Please upload large size image!"});  
                         $("#profilePicturePreview1").parent(".img_view1").attr("style", "display: none");
                         document.getElementById("profilePicturePreview1").src = "/images/defaultcamera.png";
                         $("#photoUrlInput1").val('');
                         $("#dataurl_2101").val('');
                         $("#dataurl_6401").val('');
                         $("#dataurl_640_img1").val('');
                         $("#dataurl_210_img1").val('');
                         $('#large_challenge_image_btn1').trigger('click');
                    }else
                    {

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);
                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');
                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_640;
                    const cropHeight = custom_width_640;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;
                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;
                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');
                    var dataurl_640 = croppedDataURL; 

                    //new
                     if(custom_width_210)
                {
                    var canvas = document.createElement("canvas");                    
                    const canvasResize = document.createElement('canvas');
                    const ctxResize = canvasResize.getContext('2d');                    
                    const maxWidth = 500; 
                    const maxHeight = 500; 
                    const aspectRatio = img.width / img.height;
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth) {
                        newWidth = maxWidth;
                        newHeight = newWidth / aspectRatio;
                    }
                    if (newHeight > maxHeight) {
                        newHeight = maxHeight;
                        newWidth = newHeight * aspectRatio;
                    }

                   

                    canvasResize.width = newWidth;
                    canvasResize.height = newHeight;
                    ctxResize.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);

                    const resizedDataURL = canvasResize.toDataURL('image/jpeg');

                    const canvasCrop = document.createElement('canvas');
                    const ctxCrop = canvasCrop.getContext('2d');
                    const cropWidth = custom_width_210;
                    const cropHeight = custom_width_210;
                    canvasCrop.width = cropWidth;
                    canvasCrop.height = cropHeight;
                    const x = (newWidth - cropWidth) / 2;
                    const y = (newHeight - cropHeight) / 2;
                    ctxCrop.drawImage(canvasResize, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const croppedDataURL = canvasCrop.toDataURL('image/jpeg');
                    var dataurl_210 = croppedDataURL;
                    /*new code 1*/
                  
                }
                if(dataurl_640!==undefined || dataurl_210!==undefined)
                {
                const dataurl_210s = document.getElementById('dataurl_2101');
                dataurl_210s.value = dataurl_210;
                const dataurl_640s = document.getElementById('dataurl_6401');
                dataurl_640s.value = dataurl_640;
                
                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });

                parseFile_640.save().then((savedFile) => {
                 const dataurl_640_img = document.getElementById('dataurl_640_img1');
                 dataurl_640_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });
                parseFile_210.save().then((savedFile) => {
                 const dataurl_210_img = document.getElementById('dataurl_210_img1');
                 dataurl_210_img.value = savedFile.url();
                }).catch((error) => {
                  console.error('Error saving file:', error);
                });
                $("#profilePicturePreview1").parent(".img_view1").attr("style", "display: block");
                 document.getElementById("profilePicturePreview1").src = dataurl_640;
              }


                    //new
                   }
                }
               
                    
            }
                    img.src = e.target.result;
                }
                reader.readAsDataURL(imageFile);
            }else {
              console.log('Unsupported file type.');
               self.setState({create_message_show:true});  
               self.setState({create_message:'Unsupported file type.'}); 
              // You can display an error message or take other actions here
            }
            $('#close_Postmodalwithdiscard1').attr("style", "display: block");
            $('#close_Postmodal1').attr("style", "display: none");
            /*if ($(".modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
               $(".modal.fade.post_modal.createPostModal").removeClass("post_modal_overlay");
            }*/
          }
          setTimeout(() => {
          self.setState({create_message_show:false});  
          self.setState({create_message:null}); 
          self.setState({photo_image_message:null});           
        }, 3000);
     }
  };

    checkChallengeDiscard = function(e){       
    setTimeout(() => {
     $('#close_Postmodal1').trigger('click');    
     $("#photoUrlInput1").val('');
     $("#dataurl_2101").val('');
     $("#dataurl_210_img1").val('');
     $("#dataurl_6401").val('');
     $("#dataurl_640_img1").val('');     
     $("#caption1").val('');
     $("#profilePicturePreview1").parent(".img_view1").attr("style", "display: none");
     document.getElementById("profilePicturePreview1").src = "/images/defaultcamera.png";
    },500);       
    $('#close_Postmodalwithdiscard1').attr("style", "display: none");
    $('#close_Postmodal1').attr("style", "display: block");
    if (!$("#addChallengeModal.modal.fade.post_modal.createPostModal").hasClass("post_modal_overlay")) {
         $("#addChallengeModal.modal.fade.post_modal.createPostModal").addClass("post_modal_overlay");
      }
  }

    handleChallengeSubmit(event) {
     event.preventDefault();
     var forms = document.forms.new_challenge_form;
     var caption=forms.caption1.value;
     var dataurl_210=forms.dataurl_2101.value;
     var dataurl_640=forms.dataurl_6401.value;   
     var dataurl_210_img=forms.dataurl_210_img1.value;
     var dataurl_640_img=forms.dataurl_640_img1.value;

     var self = this;  
     if(caption==='')
         {
          self.setState({create_message:"Please write some caption first!"});  
          
         }else if(dataurl_210==='' || dataurl_210_img==='')
         {
          self.setState({create_message:'Please upload image.'});            
         }else
         {
           
            const currentUser = Parse.User.current();
            if (currentUser) {
                const parseFile_210 = new Parse.File('image.jpg', { base64: dataurl_210 });
                const parseFile_640 = new Parse.File('thumbnail.jpg', { base64: dataurl_640 });
                const Photo = Parse.Object.extend('Photo');
                const photo = new Photo();
                let currentUser = Parse.User.current();             
                photo.set('image', parseFile_640);  
                photo.set('thumbnail', parseFile_210);
                photo.set('nonMealPost', 1);
                photo.set('user', currentUser);
                photo.set('caption', caption);
                photo.set('fulltext', caption);   
                photo.set('isChallengeEntry', "1");  
                photo.set('challenge', this.state.challenge); 
                photo.set('impr', 0);
                

                    photo.save().then((photodata) => {
                       /*this.toggleNotification(this.challenge_id,'joined a challenge','');
                       self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});   */
                      this.checkChallengeDiscard();
                      $('#challenge_entry_submitted').trigger('click');
                      console.log('photodata.id'+photodata.id);
                      self.toggleNotification(photodata.id,'posted to your challenge','');
                      self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                      setTimeout(() => {
                        $("#caption1").val('');

                        },3000);
                     }).catch((error) => {
                        console.log(error.message);
                     });  
                           
            } else {
            }

            /* setTimeout(() => {
                       this.checkChallengeEntries(this.challenge_id);
                        },500);*/
            
         }
         
         setTimeout(() => {
          self.setState({create_message_show:false});  
          self.setState({create_message:null}); 
           this.checkChallengeEntries(this.challenge_id);
          // this.toggleNotification(this.challenge_id,'posted to your challenge','');
           // self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
          
           
        }, 20000);
    }
    checkChallengeEntries(challenge_id) {

        var query = new Parse.Query('Photo');
        query.equalTo('isChallengeEntry', "1");
        query.equalTo('challenge', "Photo$"+this.challenge_id);
         query.select("isChallengeWinner");
        query.select("isChallengeEntry");
        query.select("hideEntry");
        query.select("image");
        query.select("thumbnail");
        query.select("isRecipe");

        query.include("user");
        query.include("image");
        query.include("thumbnail");      
        query.exists("user");

        
        query.descending("createdAt");
        query.limit(100);

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({entries: result});
            }
        })


    }
    checkChallengeIsAvailable(challenge_id) {
      var query = new Parse.Query('Photo');
      query.equalTo("objectId", challenge_id);
      //query.containedIn('challengeStatus',["Active","Billed"]);
      var self = this;
        query.first().then(function(result){
            if(result){ console.log(result);
                let challengeTitle=result.get('challengeTitle');
                let caption=result.get('caption');
                let challengeHashtag=result.get('challengeHashtag');
                let image=result.get('image');
                let thumbnail=result.get('thumbnail');
                let prize=result.get('prize');
                let sponsor=result.get('businessAccount');
                let challengeStatus=result.get('challengeStatus');
                
                 self.setState({challenge: result});
                if(challengeTitle)
                {
                     self.setState({challengeTitle: challengeTitle});
                }
                if(caption)
                {
                     self.setState({caption: caption});
                }
                if(challengeHashtag)
                {
                     self.setState({challengeHashtag: challengeHashtag});
                }
                if(prize)
                {
                     self.setState({prize: prize});
                }
                if(sponsor)
                {
                     self.setState({sponsor: sponsor});
                }
                
               if(image)
               {
                    //self.setState({challenge_image: thumbnail.url()});
                    self.setState({challenge_image: image.url()});
               }       
               if(challengeStatus)
               {
                  self.setState({challengeStatus: challengeStatus});
               }    
            }else{
                //window.location.href = "/explore";
            }
        })
    }
    renderEntries()
    {
          
          let entryrecord = [];
          var isPopupOpen= this.state.isPopupOpen;
          var postcommonid= this.state.post_common_id;
          const togglePopup = (postid) => {
            
            this.setState(prevState => ({
              isPopupOpen: !prevState.isPopupOpen,
            }));
            this.setState({ post_common_id: postid });
          };
        const streamid= (postid) =>{
           localStorage.setItem('storestreamid', postid);
        }


          if (this.state.entries)
        {
            for (var i = 0; i < this.state.entries.length; i++)
            {
                 var postdata = this.state.entries[i];                 
                 let postdata_id=postdata.id;
                 let hideEntry=postdata.get("hideEntry")?postdata.get("hideEntry"):'0';
                 if(hideEntry==="0")
                 {
                    {/*href='javascript:void(0);' onClick={(e) => {togglePopup(postdata_id);}}*/}
                 entryrecord.push( <div class="gridPost" key={69*i}> 

                    <a href = "/stream" onClick={(e) => {streamid(postdata_id);}}  >
                                     {/*      <a href={"/post/"+postdata.id}>*/}
                                        <div className='chlng-icon'>
                                          {/* <img src='/images/chlng-wnr.png' className='chlng-wnr' /> */}
                                        {/*  <img src='/images/chlng-entry.png' className='chlng-entry' />*/}
                                <div className='chlng-icon'>
                                {postdata.get("isChallengeWinner")!==undefined && postdata.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                {/*postdata.get("isChallengeEntry")!==undefined && postdata.get("isChallengeEntry")==="1" && !postdata.get("isChallengeWinner") && <img src='/images/chlng-entry.png' className='chlng-wnr' />*/}
                                {postdata.get("isRecipe")!==undefined && postdata.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                        </div>
                                            <figure class="thumbnail">
                                                <img  src={postdata.get("image")?postdata.get("image").url():''} />
                                            </figure>
                                        </a>
                                    </div>);  
                  }


            }

        }
         return (  <div className='explr_list_grid'>
                                <div class="gridPostRow">
                              
                           {entryrecord}
                 </div>  <CommonPopup   isOpen={isPopupOpen} onClose={(e) => {togglePopup(postcommonid);} } postcommonid={postcommonid} />    
                            </div>
        //}
        );
    }
    render() {    
        let challenge_image=this.state.challenge_image;
        let challengeTitle=this.state.challengeTitle;
        let caption=this.state.caption;
        let challengeHashtag=this.state.challengeHashtag;
        let prize=this.state.prize;
        let sponsor=this.state.sponsor;
        let challengeStatus=this.state.challengeStatus;
        let currentUser = Parse.User.current(); 
        var isNotificationOpen=this.state.isNotificationOpen; 
        var post_Notification_Ids=this.state.post_Notification_Id; 
        var post_Notification_Msg=this.state.post_Notification_Msg;
        var post_Notification_Comment=this.state.post_Notification_Comment;
        return (
            <section className='challenge_entry_popup post_list'>    {isNotificationOpen?<SaveNotification   isOpen={isNotificationOpen}  postNotificationid={post_Notification_Ids} postMsg={post_Notification_Msg} postPhotoid={post_Notification_Ids} postActivityComment={post_Notification_Comment} />:""} 
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                        <main className='listing explr-list '>
                            <div className='explr_list_hreo'>
                                <div className='listing-box'>
                                    <div className='bg-img'>
                                       {/* <img className="d-block w-100" src="/images/default_userpic0.png" alt="Soup for the Soul" />*/}
                                    {challenge_image!==null?
                                   <img className="d-block w-100" src={challenge_image} alt={challengeTitle} />
                                    :  <img className="d-block w-100" src="/images/emptygrid.png" alt="" />
                                }
                                  
                                    </div>                                
                                    <div className='detail'>
                                      <h1>{challengeTitle}</h1>
                                      <h2>{prize?"$"+prize.toString().replace(/,/g,"").replace(/\B(?=(\d{3})+(?!\d))/g, ",")+" in prizes":""}</h2>
                                      <h3>{sponsor?"Sponsored by "+sponsor:""}</h3>
                                    </div>
                                </div>
                                <div className='explr_cotent'>
                                    <p>{caption}{/*Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sin <a href='#' title='#soup'>#soup</a>*/}
                                {/*challengeHashtag*/}

                                </p>
                                {challengeStatus==="Active" && currentUser?
                                    <div className="join_challange ">
                                        <div className='cta_btn btn-wrp'>
                                            <a href='javascript:void(0);' type="button" data-toggle="modal" data-target="#createPostModalchallenge">Join Challenge</a>
                                        

                                        </div>
                                    </div>
                                    :""}
                                    {challengeStatus==="Active" && !currentUser?
                                    <div className="join_challange ">
                                        <div className='cta_btn btn-wrp'>
                                            <a href='javascript:void(0);' type="button" disabled>Join Challenge</a>
                                        

                                        </div>
                                    </div>
                                    :""}
                                </div>
                            </div>
                            
                                   {/* <div class="gridPost">
                                        <a href="/post/pasdunb4ED">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg"/>
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/2EsYcZIBii">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>
                                    <div class="gridPost">
                                        <a href="/post/WmL3QeLgGE">
                                            <figure class="thumbnail">
                                                <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                            </figure>
                                        </a>
                                    </div>*/}
                                  {this.renderEntries()}
                              
                        </main>
                    </div>
                </div>

                {/*popup*/}

       {/* <a href='javascript:void(0);' type="button" data-toggle="modal" data-target="#createChallengeModal" >
                      Create Challenge
                    </a>*/}

        <div className="modal fade post_modal createPostModal post_modal_overlay createPostModalchallenge" id="createPostModalchallenge" tabIndex="-1" role="dialog" data-backdrop="false" data-keyboard="true" aria-labelledby="createPostModalTitle" aria-hidden="true">
          <div class="bg_overlay"></div>
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <form id="new_challenge_form" onSubmit={this.handleChallengeSubmit}> 
              <div className="modal-content">
                <div className="top-part">
                  <button type="button" style={{display:"none"}} onClick={this.checkPostModal}   className="close" data-toggle="modal" data-target="#createPostCloseModal1" id="close_Postmodalwithdiscard1" aria-label="Modal">
                    <img src="/images/close.svg" alt="Close"/>
                  </button>
                  <button type="button"  className="close" data-dismiss="modal" id="close_Postmodal1" aria-label="Modal"  onClick={this.discardData}>
                    <img src="/images/close.svg" alt="Close"/>
                  </button>
                  <h5 className="modal-title">Challenge Entry</h5>

                  <div className='cta_btn third-btn'>
                    <button  className="submit">Post</button>
                  </div>
                 
                </div>
                <div className="modal-body"> 
                  <div className='inner'> 
                    <div className='left-part'>
                      <label htmlFor="myFile1">
                        <p className='create_message_alert'>{this.state.create_message}{this.state.photo_image_message}</p>
                        <div className='file_upld'>
                          {/*new*/}
                          <div className='img_view1' style={{display:"none"}}>
                            <img height="" width="250" id="profilePicturePreview1" src="/images/defaultcamera.png" alt="photo Picture" />
                          </div>
                          {/*new*/}
                          <div className='file-input'>
                            <p>
                              <input type="hidden" id="photoUrlInput1" name="photoUrl1"/>
                              <input type="hidden" id="dataurl_2101" name="dataurl_2101"/>
                              <input type="hidden" id="dataurl_6401" name="dataurl_6401"/>
                              <input type="hidden" id="dataurl_640_img1" name="dataurl_640_img1"/>
                              <input type="hidden" id="dataurl_210_img1" name="dataurl_210_img1"/>
                              <img src="/images/file_upload.svg" alt="Joel's Kitchen"/>
                              <span>Choose a file to upload.</span>
                            </p>
                          </div>
                          <div className='file-infor'>
                            <label>We recommend using high quality .jpg & .png files less than 20MB.</label> 
                          </div>
                        </div>
                        <input type="file" id="myFile1"  accept=".jpg, .jpeg, .png"  name="filename1"  onChange={this.handleChallengeFileChange} />
                      </label>  
                    </div>
                    <div className='right-part'>
                      <div className='post-comment'>
                      {/*  <textarea id="createPosttxt" name="createPosttxt" rows="10" placeholder="Write a caption..."></textarea>*/}
                        <textarea name="caption1"  id="caption1"  onChange={this.changeChallengeCaption}  rows="10" placeholder="Write a caption..."></textarea>
                       
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div> 


         <div className="modal fade post_modal post_modal_overlay createPostCloseModal" id="createPostCloseModal1" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <h6>Are you sure you want to leave?</h6>
                    <p>If you exit, your post won’t be saved.</p>
                  </div>
                  <div className='action-part'>
                    <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Discard'  onClick={this.checkChallengeDiscard}>Discard</a>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel'  onClick={this.checkCancel} data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


<button href='javascript:void(0);' id="large_challenge_image_btn1" type="button" data-toggle="modal" data-target="#large_challenge_image1"  style={{display:"none"}}>submit</button>
        <div className="modal fade post_modal post_modal_overlay createPostCloseModal large_challenge_image" id="large_challenge_image1" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <p>{/*Please upload a larger size image!*/}{this.state.challenge_image_msg_size}</p>
                    
                  </div>
                  <div className='action-part'>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Close'>Close</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  

  <button href='javascript:void(0);' id="challenge_entry_submitted" type="button" data-toggle="modal" data-target="#chnlgEntryConfrModal"  style={{display:"none"}} >submit</button>
        <div className="modal fade post_modal post_modal_overlay createPostCloseModal chnlgPostupdateConfrModal" id="chnlgEntryConfrModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <h6>Thank you for submitting your entry!</h6>
                   
                  </div>
                  <div className='action-part'>
                       <a href='javascript:void(0);'  onClick={this.checkChallengeDiscard} className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Close'>Close</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


                {/*popup*/}
            </section>      
        );
    }
}

export default ChallengeDetail;


// WEBPACK FOOTER //
// ./src/ChallengeDetail.jsx